/* eslint react/prefer-stateless-function: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactRouterPropTypes from 'react-router-prop-types';
import {
  View,
  ScrollView,
  Image,
} from 'react-native';
import {
  Text,
  Button,
} from 'react-native-elements';
import { graphql } from '@apollo/client/react/hoc';
import { compose } from 'ramda';
import Header from '../../components/misc/Header';

import { sprintf } from '../../../vendor/sprintf-js';
import styles from '../../styles';
import AORTypes from '../../types';
import { translate } from '../../locales/i18n';
import { currency } from '../../money';
import methods, { payPeriod } from '../../modules/payout';
import GetBalances from '../../q/GetBalances';
import { AppSyncClientAuthenticated } from '../../backends/AppSyncClient';

class PublisherSettings extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.selectMethod = this.selectMethod.bind(this);

    // eslint-disable-next-line react/no-unused-class-component-methods
    this.displayName = 'PublisherSettings';
  }

  selectMethod(id) {
    const { history } = this.props;

    history.push(`/publishermethod/${id}`);
  }

  render() {
    const {
      userData,
      balancesThisMonth,
      balancesPreviousMonth,
      history,
    } = this.props;

    if (!userData) {
      console.log('no userData');

      return (
        <>
        </>
      );
    }
    // console.log('userData');
    // console.log(userData);
    console.log('payPeriod');
    console.log(payPeriod);

    let textThisMonth = '';
    balancesThisMonth.forEach((balance) => {
      const value = sprintf('%.2f', balance.amount);
      if (textThisMonth !== '') {
        textThisMonth += '\n';
      }
      textThisMonth += `${value}${'\u00a0'}${balance.currency}`;
    });
    if (textThisMonth === '') {
      textThisMonth = `0.00${'\u00a0'}${currency}`;
    }

    let textPreviousMonth = '';
    balancesPreviousMonth.forEach((balance) => {
      const value = sprintf('%.2f', balance.amount);
      if (textPreviousMonth !== '') {
        textPreviousMonth += '\n';
      }
      textPreviousMonth += `${value}${'\u00a0'}${balance.currency}`;
    });
    if (textPreviousMonth === '') {
      textPreviousMonth = `0.00${'\u00a0'}${currency}`;
    }

    return (
      <View
        style={styles.view.headed}
      >
        <Header
          name={translate('menu_revenue')}
          hasCancel
          history={history}
        />

        <ScrollView
          style={{
            flex: 1,
            // ...(Platform.OS === 'web' ? {
            width: '80%',
            alignSelf: 'center',
            // } : {}),
          }}
        >
          <Text h4>{translate('revenue_method')}</Text>
          <Text
            style={{
              paddingTop: 20,
            }}
          >
            {translate('revenue_method_comment')}
          </Text>

          <View
            style={{
              paddingVertical: 20,
            }}
          >
            {Object.keys(methods).map((id) => (
              <View
                key={id}
                style={{
                  flex: 1,
                  flexDirection: 'row',
                  paddingLeft: 10,
                  marginBottom: 20,
                }}
              >
                {methods[id].logo !== undefined && (
                  <Image
                    style={{
                      marginRight: 10,
                      alignSelf: 'center',
                      height: 30,
                      width: 50,
                    }}
                    //  width={120}
                    //  height={120}
                    source={methods[id].logo}
                    resizeMode="contain"
                  />
                )}
                <View
                  style={{
                    flex: 1,
                    flexDirection: 'column',
                    justifyContent: 'center',
                  }}
                >
                  <Text
                    style={{
                      fontWeight: 'bold',
                    }}
                  >
                    {translate(methods[id].name)}
                  </Text>
                  <Text
                    style={{
                      color: '#666',
                    }}
                  >
                    {translate(methods[id].comment)}
                  </Text>
                </View>
                {userData.payout === id ? ( // eslint-disable-line no-nested-ternary
                  methods[id].configurable ? (
                    <Button
                      title={translate('configure')}
                      containerStyle={[styles.button.primaryContainer, { width: 130 }]}
                      buttonStyle={[styles.button.primary, { width: 120 }]}
                      titleStyle={styles.button.primaryTitle}
                      onPress={() => this.selectMethod(id)}
                      loadingProps={{ size: 'small', color: 'white' }}
                    />
                  ) : (
                    <Button
                      title={translate('selected')}
                      containerStyle={[styles.button.secondaryContainer, { width: 130 }]}
                      buttonStyle={[styles.button.secondary, { width: 120 }]}
                      disabledStyle={styles.button.secondaryDisabled}
                      titleStyle={styles.button.secondaryTitle}
                      disabledTitleStyle={styles.button.secondaryTitleDisabled}
                      disabled
                    />
                  )
                ) : (
                  <Button
                    title={translate('button_select')}
                    containerStyle={[styles.button.primaryContainer, { width: 130 }]}
                    buttonStyle={[styles.button.primary, { width: 120 }]}
                    titleStyle={styles.button.primaryTitle}
                    onPress={() => this.selectMethod(id)}
                    loadingProps={{ size: 'small', color: 'white' }}
                  />
                )}
              </View>
            ))}
          </View>

          <Text h4>{translate('revenue_payouts')}</Text>
          {/* <Text
            style={{
              paddingTop: 20,
            }}
          >
            Choose the way to transfer funds to you:
          </Text> */}

          {/* the list of details */}
          <View
            style={{
              paddingVertical: 20,
            }}
          >
            {/* one detail: next payment date */}
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                paddingLeft: 10,
                marginBottom: 20,
              }}
            >
              {/* the description column */}
              <View
                style={{
                  flex: 1,
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Text
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  {translate('revenue_payouts_next')}
                </Text>
                <Text
                  style={{
                    color: '#666',
                  }}
                >
                  {translate('revenue_payouts_next_fixed')}
                </Text>
              </View>
              {/* the action button */}
              <Button
                title={PublisherSettings.next()}
                containerStyle={[styles.button.secondaryContainer, { width: 130 }]}
                buttonStyle={[styles.button.secondary, { width: 120 }]}
                disabledStyle={styles.button.secondaryDisabled}
                titleStyle={styles.button.secondaryTitle}
                disabledTitleStyle={styles.button.secondaryTitleDisabled}
                loadingProps={{ size: 'small', color: 'white' }}
                disabled
              />
            </View>

            {/* one detail: currency */}
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                paddingLeft: 10,
                marginBottom: 20,
              }}
            >
              {/* the description column */}
              <View
                style={{
                  flex: 1,
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Text
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  {translate('revenue_payouts_currency')}
                </Text>
                <Text
                  style={{
                    color: '#666',
                  }}
                >
                  {translate('revenue_payouts_currency_comment')}
                </Text>
              </View>
              {/* the action button */}
              <Button
                title={currency}
                containerStyle={[styles.button.secondaryContainer, { width: 130 }]}
                buttonStyle={[styles.button.secondary, { width: 120 }]}
                disabledStyle={styles.button.secondaryDisabled}
                titleStyle={styles.button.secondaryTitle}
                disabledTitleStyle={styles.button.secondaryTitleDisabled}
                loadingProps={{ size: 'small', color: 'white' }}
                disabled
              />
            </View>

            {/* one detail: funds ready */}
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                paddingLeft: 10,
                marginBottom: 20,
              }}
            >
              {/* the description column */}
              <View
                style={{
                  flex: 1,
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Text
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  {translate('revenue_payouts_ready')}
                </Text>
                <Text
                  style={{
                    color: '#666',
                  }}
                >
                  {translate('revenue_payouts_ready_comment')}
                </Text>
              </View>
              {/* the action button */}
              <Button
                title={textPreviousMonth}
                containerStyle={[styles.button.secondaryContainer, { width: 130 }]}
                buttonStyle={[styles.button.secondary, { width: 120 }]}
                disabledStyle={styles.button.secondaryDisabled}
                titleStyle={styles.button.secondaryTitle}
                disabledTitleStyle={styles.button.secondaryTitleDisabled}
                loadingProps={{ size: 'small', color: 'white' }}
                disabled
              />
            </View>

            {/* one detail: funds not yet ready */}
            <View
              style={{
                flex: 1,
                flexDirection: 'row',
                paddingLeft: 10,
                marginBottom: 20,
              }}
            >
              {/* the description column */}
              <View
                style={{
                  flex: 1,
                  flexDirection: 'column',
                  justifyContent: 'center',
                }}
              >
                <Text
                  style={{
                    fontWeight: 'bold',
                  }}
                >
                  {translate('revenue_payouts_not_ready')}
                </Text>
                <Text
                  style={{
                    color: '#666',
                  }}
                >
                  {translate('revenue_payouts_not_ready_comment')}
                </Text>
              </View>
              {/* the action button */}
              <Button
                title={textThisMonth}
                containerStyle={[styles.button.secondaryContainer, { width: 130 }]}
                buttonStyle={[styles.button.secondary, { width: 120 }]}
                disabledStyle={styles.button.secondaryDisabled}
                titleStyle={styles.button.secondaryTitle}
                disabledTitleStyle={styles.button.secondaryTitleDisabled}
                loadingProps={{ size: 'small', color: 'white' }}
                disabled
              />
            </View>
          </View>

          {/* <View
            style={{
              flexDirection: 'row',
            }}
          >
            <View
              style={{
                flex: 1,
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Button
                title={translate('button_back')}
                containerStyle={styles.buttonfsf.secondaryContainer}
                buttonStyle={styles.buttonfsf.secondary}
                titleStyle={styles.buttonfsf.secondaryTitle}
                onPress={() => { history.go(-1); }}
                loadingProps={{ size: 'small', color: 'white' }}
              />
            </View>
          </View> */}
        </ScrollView>
      </View>
    );
  }
}

PublisherSettings.next = () => {
  const today = new Date();
  const second = Math.ceil(today.valueOf() / 1000);
  const day = Math.ceil(second / (24 * 3600));
  const month = Math.ceil(day / 30);
  const nextDay = month * 30;
  const nextSecond = nextDay * 24 * 3600;
  const nextMillisecond = nextSecond * 1000;
  const nextDate = new Date(nextMillisecond);

  return nextDate.toLocaleDateString();
};

PublisherSettings.propTypes = {
  userData: AORTypes.User.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  balancesThisMonth: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  balancesPreviousMonth: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
};


export default compose(
  graphql(GetBalances, {
    props: (props) => {
      console.log('props');
      console.log(props);
      return {
        balancesThisMonth: props.data.getBalances ? props.data.getBalances.items : [],
      };
    },
    options: (props) => ({
      variables: {
        mnth: payPeriod,
      },
      client: AppSyncClientAuthenticated(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientAuthenticated(),
  }),
  graphql(GetBalances, {
    props: (props) => ({
      balancesPreviousMonth: props.data.getBalances ? props.data.getBalances.items : [],
    }),
    options: (props) => ({
      variables: {
        mnth: payPeriod - 1,
      },
      client: AppSyncClientAuthenticated(props.user),
      fetchPolicy: 'cache-and-network',
    }),
    // client: AppSyncClientAuthenticated(),
  })
)(PublisherSettings);
